@import '../../style/index';

@include host {
  @include component-margin();

  rcm-columns {
    display: grid;
    row-gap: 1.5rem;

    rcm-column {
      @include large-up() {
        --columnGap: 0.75rem;
      }

      @include xlarge-up() {
        --columnGap: 1rem;
      }

      &:hover {
        cursor: pointer;
      }
    }
  }

  .margin-big-screen {
    @include xxlarge-up() {
      max-width: calc(100% - 72px) !important;
    }
  }

  rcm-wrapper-link {
    height: 100%;

    .item {
      display: flex;
      flex-direction: column;
      height: 100%;
      &__content {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background: var(--colors-basic-white);
        color: var(--colors-dark-base);
        box-shadow: 0 2px 12px #0000001a;
        padding: rem-calc(32px);
        border-bottom: 2px solid #fbf315;
        min-height: rem-calc(450px);
        flex: 1;

        &-headline,
        &-cta {
          margin-top: 0;
          word-break: break-word;
          hyphens: auto;
        }

        &-subline {
          @include copy-secondary();

          color: var(--colors-grey-dark);
          display: -webkit-box;
          -webkit-line-clamp: 6;
          -webkit-box-orient: vertical;
          /* stylelint-disable-line */
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &-meta {
          display: flex;
          justify-content: space-between;
          font-size: rem-calc(16px);
          width: 100%;
          margin-top: auto;

          &__icon {
            display: flex;
            justify-content: flex-end;
          }
        }

        span {
          font-size: rem-calc(12px);
          letter-spacing: 0;
          color: var(--colors-grey-dark);
        }
      }

      &__image {
        height: rem-calc(220px);
        position: relative;

        &-hidden {
          height: 0;
        }

        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }

        &::after {
          content: '';
          z-index: 1;
          position: absolute;
          bottom: 0;
          left: rem-calc(32px);
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 20px 20px;
          border-color: transparent transparent var(--colors-basic-white);
        }
      }

      &__link {
        margin-top: 0;
      }
    }
  }

  .margin-bottom {
    rcm-column {
      margin-bottom: var(--spacings-l);
    }
  }

  .related-articles {
    flex-direction: column;
    align-items: flex-end;
  }
}
